function initAlerts() {
	if ($('#alert_modal').length) {
		var cookie_id = 'wellness-popup-' + $('#alert_modal').data('cookie-id');

		if ($.cookie(cookie_id) != "shown") {
			$.magnificPopup.open({
				items: {src: '#alert_modal'},
				type: 'inline',

			}, 0);

			$.cookie(cookie_id, 'shown', {
				expires: 2, path: '/'
			});
		}
	}
}